
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import { store, ShopModule } from "@returns-centre/store";

@Component
export default class ReturnsInformation extends Vue {
    shopModule = getModule(ShopModule, store);
}
